<template lang="html">
  <footer class="footer cw-footer is-charcoal is-bold">
    <div class="level featured-area">
      <div class="level-item is-padded-medium">
        <div class="has-text-centered has-text-grey-medium">
          <a href="http://callcw.com" target="_blank"
            ><icon
              class="cw-icon-monochrome"
              name="cwMonochrome"
              scale="3"
              label="icon"
          /></a>
          <p>6325 Digital Way Suite 300 | Indianapolis, IN 46278</p>
          <ul class="ul centerit phone-numbers">
            <li><a href="tel:1-317-783-1500">317.783.1500</a></li>
            <li><a href="tel:1-844-321-3366">844.321.3366</a></li>
          </ul>
          <div class="is-growable is-padded-small" :badge="true">
            <cw-app-version />
          </div>
        </div>
      </div>
    </div>
    <div class="centerit">
      <p class="is-growable">© 2026 CW RED Mobile</p>
      <div class="fine-print-links">
        <router-link to="/privacy">
          Privacy
        </router-link>
        <router-link to="/support">
          Support
        </router-link>
        <router-link to="/app">
          App
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'cw-footer',
};
</script>

<style lang="stylus" scoped>
.cw-footer {
  padding-bottom: 1rem
}
.featured-area {
  margin-bottom: 3rem
}

a .cw-icon-monochrome {
  margin: 0.5em
  color: #aaa;
  &:hover {
    color: darken(#EB212E, 10%)
  }
}
.phone-numbers {
  margin: 0.5rem 0
  li{
    padding: 0 1rem
    &:not(:first-child){
      border-left: 1px solid #777
    }

    a {
      color: lighten(#4B494B, 35)
    }
  }
}
.fine-print-links {
  & > * {
    color: #4a4a4a
    padding: 0 1rem
  }
}
</style>
